import { render, staticRenderFns } from "./pdfShow.vue?vue&type=template&id=0a0a74b4"
import script from "./pdfShow.vue?vue&type=script&lang=js"
export * from "./pdfShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports